/** What a scope view says when its project or order answers 404: it does not exist, or the user may not see it. */
export const scopeNotFoundText = (scopeKind?: 'project' | 'order'): string => {
  const noun = scopeKind ?? 'project or order'
  return `This ${noun} was not found, or you do not have access to it. It may have been deleted, or you may have been removed from it.`
}

/** Whether a failed request was the backend's 404. */
export const isNotFoundError = (error: unknown): boolean => (error as { status?: number } | null)?.status === 404
